<template>
  <div class="admin-comment-request-index">
    <md-snackbar md-position='top center' ref='registered'>
      <span>コメントの登録が完了しました</span>
    </md-snackbar>
    <div class="wrapper">
      <header-component></header-component>
      <admin-nav-menu></admin-nav-menu>
        <md-table id="comments-table">

          <md-table-header>
            <md-table-row>
              <md-table-head>店舗名</md-table-head>
              <md-table-head>推薦コメント</md-table-head>
            </md-table-row>
          </md-table-header>

          <md-table-body>
            <md-table-row v-for="comment in commentRequests" :key="comment.id">
              <md-table-cell>
                <router-link :to="{ name: 'ShopsShow', params: { id: comment.shop_id }}">{{ comment.shop_name }}</router-link>
              </md-table-cell>
              <md-table-cell>
                <p id="comment-content">{{comment.content}}</p>
              </md-table-cell>
              <md-button class="md-raised">
                 <router-link :to="{ name: 'AdminCommentRequestsCommentsNew', params: { id: comment.doc_id } }">詳細</router-link>
              </md-button>
            </md-table-row>
          </md-table-body>
        </md-table>
      </div>
  </div>
</template>

<script>
import firebaseApp from '../../../firebaseApp'
import HeaderComponent from '../../Header.vue'
import AdminNavMenu from '../AdminNavMenu.vue'
import authenticateUser from '../../../auth'
const db = firebaseApp.firestore()
const shopsRef = db.collection('shops')

let data = {
  commentRequests: []
}

export default {
  name: 'admin-comment-request-index',
  components: {
    HeaderComponent,
    AdminNavMenu
  },
  data () {
    return data
  },
  created () {
    authenticateUser().then(() => {
      if (this.$route.query.registered) {
        this.$refs.registered.open()
      }
      db.collection('comment_requests').get().then((commentSnapshots) => {
        commentSnapshots.forEach((doc) => {
          shopsRef.doc(doc.data().shop_id).get().then(shop => {
            data.commentRequests.push(Object.assign(doc.data(), { doc_id: doc.id, shop_name: shop.data().name }))
          }).catch((error) => {
            alert('コメント追加先の店舗情報の読み込みに失敗しました.店舗が存在しない場合があります。', error)
          })
        })
      }).catch((error) => {
        alert('コメント情報の読み込みに失敗しました', error)
      })
    })
  },
  mounted () {
    this.$material.setCurrentTheme('admin')
  },
  destroyed () {
    data.commentRequests = []
    this.$material.setCurrentTheme('default')
  }
}
</script>

<style scoped>

header {
  margin-left: -45px;
}

.wrapper {
  width: 960px;
  height: auto;
  margin: 0 auto;
}

#comments-table #comment-content {
  width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.table-btn {
  width: 80px;
  padding: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/CommentRequests/Index.vue